import { render, staticRenderFns } from "./orderInvoice.vue?vue&type=template&id=6d78fddd&scoped=true&"
import script from "./orderInvoice.vue?vue&type=script&lang=js&"
export * from "./orderInvoice.vue?vue&type=script&lang=js&"
import style0 from "./orderInvoice.vue?vue&type=style&index=0&id=6d78fddd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d78fddd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d78fddd')) {
      api.createRecord('6d78fddd', component.options)
    } else {
      api.reload('6d78fddd', component.options)
    }
    module.hot.accept("./orderInvoice.vue?vue&type=template&id=6d78fddd&scoped=true&", function () {
      api.rerender('6d78fddd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/invoiceManage/orderInvoice.vue"
export default component.exports